import React from "react";
import { Shield, Award, CheckCircle, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import useTranslation from "@/hooks/useTranslation";

const Footer = () => {
  const { t, language } = useTranslation();
  
  // Get language-specific paths
  const getLocalizedPath = (path) => {
    if (language === 'es') {
      // For Spanish, use localized paths
      if (path === '/') return '/es';
      if (path === '/services') return '/es/servicios';
      if (path === '/contact') return '/es/contacto';
      if (path === '/privacy') return '/es/privacidad';
      if (path === '/terms') return '/es/terminos';
    }
    return path; // Default to English paths
  };
  
  return (
    <footer className="bg-[#000080] text-white py-12" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">{t('certifications')}</h3>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Shield className="w-5 h-5" aria-hidden="true" />
                <span>{t('hipaaCompliant')}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Award className="w-5 h-5" aria-hidden="true" />
                <span>{t('capAccredited')}</span>
              </div>
              <div className="flex items-center space-x-2">
                <CheckCircle className="w-5 h-5" aria-hidden="true" />
                <span>{t('cliaCertified')}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Shield className="w-5 h-5" aria-hidden="true" />
                <span>{t('privacyShield')}</span>
              </div>
            </div>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">{t('phone')}</h3>
            <div className="flex items-center space-x-2">
              <Phone className="w-5 h-5 flex-shrink-0" aria-hidden="true" />
              <span>972-327-8857</span>
            </div>
            
            <h3 className="text-xl font-bold mb-4 mt-6">{t('location')}</h3>
            <div className="flex items-center space-x-2">
              <MapPin className="w-5 h-5 flex-shrink-0" aria-hidden="true" />
              <address className="not-italic">
                2015 Midway Rd Bldg 111,<br />
                Carrollton, TX 75006
              </address>
            </div>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">{t('legal')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to={getLocalizedPath('/privacy')} className="hover:text-[#40E0D0] transition-colors">
                  {t('privacyPolicy')}
                </Link>
              </li>
              <li>
                <Link to={getLocalizedPath('/terms')} className="hover:text-[#40E0D0] transition-colors">
                  {t('termsOfService')}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-blue-700 text-center">
          <p>&copy; {new Date().getFullYear()} NuWav Laboratories. {t('allRightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
